<ngx-ui-loader [loaderId]="'dashboard'"></ngx-ui-loader>
<div id="denyDashboardAccess" class="background">
    <div style="padding-left: 20px;padding-right: 20px;">
    <div class="accordion" id="accordionExample">

    <div *ngIf="currentUserData.userid == 279 else realCode" class="card-header" id="headingOne">
        <div class="row ">
            <div  style="padding: 1px;" class="col-md-11">
                <h2 class="mb-0">
                    <mat-card>
                        <mat-card-content>
                    <button class="btn btn-link " type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <i class="fa fa-filter"></i>
                    Filter by Country,State,City....
                    </button>
                    </mat-card-content>
                    </mat-card>
                </h2>
            </div>
            <div style="padding: 0px;" class="col-md-1">
                <mat-card>
                    <mat-card-content>
                      <!--  <b><u>Distribution transformer online monitoring system</u></b><b style="float: right;">Site Location: Vaishali Appt. CSS, Borivali division.</b><br>
                         <b >Installed date : 03/01/2023</b><b style="float: right;">Utility name : Adani electricity mumbai Ltd.</b>-->
                         <button style="width:100%" (click)="popupAlertsTable()" class="btn btn-danger">Live Alerts</button>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>

    </div>
    <ng-template style="padding-top: 2px;" #realCode  class="card-header" id="headingOne">
        <h2 class="mb-0">
            <mat-card>
                <mat-card-content>
            <button class="btn btn-link " type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                <i class="fa fa-filter"></i>
            Filter by Country,State,City....
            </button>
            </mat-card-content>
            </mat-card>
        </h2>
    </ng-template>
    <br>
    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
      <div class="row ">
          <div class="col-md-12">
                      <div class="row" style="color: white;" >
                          <div class="col-sm-4 col-md-2">
                              <ng-select [items]="countryList" bindLabel="name" placeholder="Country"
                                  [(ngModel)]="selectedCountry" (change)="countrySelection()" [clearable]="false">
                              </ng-select>
                          </div>
                          <div class="col-sm-4 col-md-2">
                              <ng-select [items]="stateList" bindLabel="name" placeholder="State"
                                  [(ngModel)]="selectedState" (change)="stateSelection()">
                              </ng-select>
                          </div>
                          <div class="col-sm-4 col-md-2">
                              <ng-select [items]="cityList" bindLabel="name" placeholder="City"
                                  [(ngModel)]="selectedCity" (change)="citySelection()">
                              </ng-select>
                          </div>
                          <div class="col-sm-4 col-md-2">
                              <ng-select [items]="zoneList" bindLabel="name" placeholder="Zone"
                                  [(ngModel)]="selectedZone" (change)="zoneSelection()">
                              </ng-select>
                          </div>
                          <div class="col-sm-4 col-md-2">
                              <ng-select [items]="locationList" bindLabel="name" placeholder="Location"
                                  [(ngModel)]="selectedLocation" (change)="locationSelection()">
                              </ng-select>
                          </div>
                          <div class="col-sm-4 col-md-2">
                              <ng-select [items]="transformerList" bindLabel="label"
                                  placeholder="Transformer" [(ngModel)]="selectedTransformer"
                                  (change)="transformerSelection()">
                              </ng-select>
                          </div>
                      </div>
          </div>
      </div><br>
    </div>
</div>
<div class="row " >
    <div class="col-md-3" style="padding: 2px">
        <mat-card class="firstRow">
            <mat-card-content>
                <div style="height: 19vh;" id="transformerStatus"></div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-3" style="padding: 2px"> 
            <mat-card class="firstRow">
                <mat-card-content>
                    <div style="height: 19vh;" id="deviceStatus"></div>
                </mat-card-content>
            </mat-card>
        </div>
    <div class="col-md-6" style="padding:2px;">
        <mat-card class="firstRow" >
            <mat-card-content>
                <div style="height: 19vh;" id="alertStatus"></div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="row " style="padding-top:0.5% ;">
    <div class="col-md-3" style="padding:2px;">
        <mat-card class="secondRow" >
            <mat-card-content style="box-shadow: 1px 1px 1px 1px #888888;border: 1px solid #000000;">
                <div >
                  <agm-map #gm [latitude]="lat1" [longitude]="lng1"[zoom]="4" [fullscreenControl]='true' 
                      [mapTypeControl]='false' style="height:25vh;"  >
                      <agm-marker *ngFor="let data of mapData; let i = index" [latitude]="data.latitude"
                          [longitude]="data.longitude" (mouseOver)="onMouseOver(infoWindow,gm)"
                          (markerClick)="transformerClicked(data)" 
                          [iconUrl]="data.datareceived && data.alert.length == 0 ? greenTransformerPath : data.datareceived && data.alert.length > 0 ? redTransformerPath : blackTransformerPath">
                          <agm-info-window [disableAutoPan]="false" #infoWindow>
                              <p>Transformer Id: {{data.transformerid}}</p>
                              <p>Site Name: {{data.sitename}}</p>
                              <!-- <p>KVA: {{data.Kva ? (data?.Kva | number:'1.2-3') : '-'}}</p>
                              <p>KWh: {{data.Kwh ? (data?.Kwh | number:'1.2-3') : '-'}}</p>
                              <p>Load(%): {{data?.Load ? (data?.Load | number:'1.2-3') : '-'}}</p>-->
                              <p *ngIf="data.datareceived" style="color: green;">Power: On</p>
                              <span *ngIf="!data.datareceived" style="color: red;">
                                  <p>Power: Off</p>
                              </span>
                              <span *ngIf="data?.alert.length > 0" style="color: red;">
                                  <p *ngFor="let param of data.alert">
                                      {{param.parametername | slice:2}}:{{param.mparametervalue}}
                                  </p>
                              </span>
                          </agm-info-window>
                      </agm-marker>
                  </agm-map>
                  </div>
              </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-3" style="padding:2px;">
        <mat-card class="secondRow" >
            <mat-card-content>
                <div style="height: 25vh;" id="healthStatus"></div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-3" style="padding:2px;">
        <mat-card class="secondRow" >
            <mat-card-header style="display: flex;align-items: center;justify-content: center;">
                <b [ngStyle]="{ color: textColor }">Maintenance Data</b>
            </mat-card-header>
            <mat-card-content>
                <div class="grid-container">
                    <div (click)="popupTable('completeMaintenance','')" class="grid-item" style="color: rgb(75, 255, 47);cursor: pointer;">
                        <i class="fa fa-cogs">Completed</i>&nbsp; <br>
                      <b style="font-size: 7vh;">{{completeMaintenanceCount}}</b>
                    </div>
                    <div (click)="popupTable('pendingMaintenance','')" class="grid-item" style="color: rgb(255, 220, 47);cursor: pointer;">
                        <i class="fa fa-wrench">Pending</i>&nbsp; <br>
                      <b style="font-size: 7vh;">{{pendingMaintenanceCount}}</b>
                    </div>
                  </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-3" style="padding:2px;">
        <mat-card class="secondRow" >
            <mat-card-header style="display: flex;align-items: center;justify-content: center;">
                <b [ngStyle]="{ color: textColor }">Load Profile</b>
            </mat-card-header>
            <mat-card-content>
                <div class="grid-container">
                    <div mat-raised-button [matTooltip]="maxTransformerId" class="grid-item" style="color: rgb(255, 47, 47);">
                        <b>Peak Load</b>
                        <div style="height: 16vh;padding-top: 0px;margin: 0px;" id="peakLoad"></div>
                    </div>
                    <div class="grid-item" style="color: rgb(0, 255, 191);">
                        <b>Average Load</b>
                        <div style="height: 16vh;padding-top: 0px;margin: 0px;" id="loadAverage"></div>
                    </div>
                  </div>
            </mat-card-content>
        </mat-card>
        
    </div>
</div>
    <div class="row " style="padding-top:0.5% ;padding-bottom: 3vh;">
        <div class="col-md-6" style="padding:2px;">
            <mat-card class="thirdRow" style="padding: 0px;">
                <mat-card-header style="display: flex;align-items: center;justify-content: space-between;">
                    <b [ngStyle]="{ color: textColor }">Live Alerts</b>
                    <i style="padding: 1%;height: 40%;width: 5%;" (click)="popupAlertsTable()" class="fa fa-expand"></i>

                </mat-card-header>
                
                <mat-card-content style="height:27vh;overflow: auto;scroll-behavior: smooth;padding-right: 3px;padding-left: 3px;padding-bottom: 3px;">
                    <ng-container  >
                        <table class="alerts-table" id="alerttabledata" *ngIf ="latestAlertsArray.length > 0 else noData" >
                            <thead >
                              <tr style=" width: fit-content;  position: sticky; top:0">
                                <th>Date</th>
                                <th>Parameter</th>
                                <th>SiteName</th>
                                <th>Actual Value</th>
                                <th>Threshold Value</th>
                                <th>Transformer ID</th>
                              </tr>
                            </thead>
                            <tbody [ngStyle]="{ color: textColor }">
                              <tr (click)="open_individual(arr.transformerid)" class="scrolling-text" *ngFor="let arr of latestAlertsArray.slice().reverse()">
                                <td >{{ arr.date }}</td>
                                <td>{{ arr.parametername.replace('ap', '') }}</td>
                                <td>{{ arr.sitename }}</td>
                                <td style="text-align: center;">{{ arr.gparametervalue == 4 && arr.parametername == 'apOillevel' ? 'LOW' : arr.gparametervalue == 5 && arr.parametername == 'apOillevel' ? 'MEDIUM' :arr.gparametervalue == 5 && arr.parametername == 'apOillevel' ? 'HIGH':arr.gparametervalue }}</td>
                                <td style="text-align: center;">{{arr.mparametervalue  == 5 && arr.parametername == 'apOillevel' ? 'MEDIUM' : arr.mparametervalue}}</td>
                                <td>{{ arr.transformerid }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <ng-template #noData>
                            <div style="font-size: 1.5em;text-align: center;width:100%;display: block;margin-top: 20%;">
                             Alerts Not Generated.
                            </div>
                        </ng-template>
                    </ng-container>
                </mat-card-content>
                </mat-card>
        </div>
        <div class="col-md-3" style="padding:2px;">
            <mat-card class="thirdRow" [ngStyle]="{ color: textColor }">
                <mat-card-header style="display: flex;align-items: center;justify-content: center;">
                    <b >Active Power</b>
                </mat-card-header>
                <mat-card-content style="padding-left: 18px;padding-right: 18px;padding-top: 10px;">
                    <mat-card style="text-align: center;">
                        <mat-card-content  [ngStyle]="{ color: textColor }"> 
                            <div style="padding: 5px;">
                                Ongoing Maximum Active Power <br>
                                <b style="font-size: 4vh;color:crimson;">{{maxDemandValue}}</b> kW <br>
                                {{maxDemand}}
                             </div>
                        </mat-card-content>
                    </mat-card>
                    <mat-card style="text-align: center;margin-top: 8px;">
                        <mat-card-content  [ngStyle]="{ color: textColor }"> 
                            <div style="padding: 5px;">
                                Ongoing Average Active Power <br>
                                <b style="font-size: 4vh;color:darkorange;">{{averageDemand}}</b> kW <br>
                                
                             </div>
                        </mat-card-content>
                    </mat-card>
                    
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-md-3" style="padding:2px;">
            <mat-card class="thirdRow" [ngStyle]="{ color: textColor }">
                <mat-card-header style="display: flex;align-items: center;justify-content: center;">
                    <b >Warnings</b>
                </mat-card-header>
                <mat-card-content >
                    <div  style="height: 28vh; overflow-y: auto; font-size: 1.8vh; padding: 4px; border: 1px solid #32326d; border-radius: 8px;">
                        <div *ngFor="let warnings of warningDataArray" style="padding-bottom: 10px; margin-bottom: 10px; border-bottom: 2px solid #d9534f;">
                          <strong style="color: #d9534f;">Warning:</strong> {{ warnings }}
                        </div>
                      </div>                      
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
 </div>       <!--<div class="row">
            <div class="col-md-6">
            </div>
            <button class="mdc-fab app-fab--absolute" color="warn" (click)='openAlertBox()' aria-label="alert">
                <div class="mdc-fab__ripple"></div>
                <p style="color: whitesmoke;"></p>
                <span class="material-icons" style="color: whitesmoke;">
                    notifications_active
                </span>
            </button>
        </div>-->
